/**
 * Feeney 'Modern' railing rules (spec "Feeney DesignRail Modern - Add to
 * Planners", p.2).
 *
 * These are permanent product rules and stay once Feeney publishes the real
 * Modern products — unlike modern-local.config.ts, which is only the
 * temporary donor-based catalog. Both the 3D build and the quote read the
 * rules from here so the two cannot drift apart.
 */

export const MODERN_RAILING_TYPE = 'Modern';

/** Rule 1: kit lengths in feet — 6 ft always, 8 ft only at 36" height. */
export const MODERN_DEFAULT_SPAN = '6';

/**
 * Rule 1: the chosen kit length in inches, which caps the post spacing.
 */
export function modernSpanInches(sectionSpan: string): number {
  return (+sectionSpan || +MODERN_DEFAULT_SPAN) * 12;
}

/**
 * Rule 5: a section longer than one 6 ft kit carries two evenly spaced
 * intermediate pickets instead of one. Sections under 36" get none, but that
 * floor is shared with every other railing type and lives in InfillsService.
 */
export const MODERN_TWO_PICKET_ABOVE_INCHES = modernSpanInches(MODERN_DEFAULT_SPAN);



// WEBPACK FOOTER //
// ./src/app/models/2d3d/modern.config.ts